import React, { useState, useEffect } from "react"

import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Button,
  Input,
} from "reactstrap"
// validation Validation
import * as Yup from "yup"
// import { usevalidation } from "validation"
import { useFormik } from "formik"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { ToastContainer, toast } from "react-toastify"
import API from "../../api/axios"
import DeleteModel from "./DeleteModel"

const ServiceProfile = () => {
  //meta title
  document.title = "Profile | Skote - React Admin & Dashboard Template"
  const dispatch = useDispatch()
  const location = useLocation()

  const navigate = useNavigate()
  const [serviceData, setServiceData] = useState(
    location.state?.serviceData || {},
  )
  const [durations, setDurations] = useState([])
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: serviceData?.id,
      name: serviceData?.name || "",
      price: serviceData?.price || "",
      durationId: serviceData?.durationId || "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()

        .required("Service name is required"),
      price: Yup.string()

        .required("Price is required"),
      durationId: Yup.string().required("Duration is required"),
    }),

    onSubmit: async values => {
      console.log("Submitting values", values)

      await updateService(values)
    },
  })

  const { isSubmitting } = validation

  const updateService = async updatedData => {
    try {
      const authToken = localStorage.getItem("authToken")
      console.log("Sending updated data:", updatedData)

      const response = await API.put(
        `/services/${updatedData.id}`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )
      console.log("api response", response)

      if (response.status === 200) {
        toast.success("User updated successfully ", { autoClose: 2000 })
        setServiceData()
        setTimeout(() => {
          navigate("/service")
        })
      } else {
        toast.error("Failed to update service. Please try again.")
      }
    } catch (error) {
      console.error("Error updating patient data:", error)
      toast.error("Error updating patient.")
    }
  }

  const handleDelete = () => {
    if (!serviceData || !serviceData.id) {
      toast.error("Invalid user data.")
      return
    }
    setShowDeleteModal(true) // open modal
  }

  const confirmDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken")
      const response = await API.delete(
        `/services/${serviceData.id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )

      if (response.status === 200) {
        toast.success("service deleted successfully!", { autoClose: 2000 })
        setShowDeleteModal(false)
        navigate("/service")
        // props.refreshTable(); // Notify parent to refresh list
        // setPatientData() // Clear patient data after deletion
      } else {
        toast.error("Failed to delete service. Please try again.")
      }
    } catch (error) {
      console.error("Error deleting service:", error)
      toast.error("Error deleting service.")
    }
  }

  const fetchDurations = async () => {
    try {
      const authToken = localStorage.getItem("authToken")
      const res = await API.get("/duration", {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      })
      setDurations(res.data)
    } catch (error) {
      console.error("Failed to fetch durations", error)
    }
  }

  useEffect(() => {
    fetchDurations()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content p-0">
        <Container>
          <h4 className="card-title mb-4">Change Service Profile</h4>
          <Card>
            <CardBody>
              <form
                action=""
                className="form-horizontal"
                onSubmit={validation.handleSubmit}
              >
                <Row>
                  <Col md={4}>
                    <Label>Service Name</Label>
                    <Input
                      name="name"
                      type="text"
                      placeholder="Enter service name"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.name}
                      invalid={
                        validation.touched.name && validation.errors.name
                      }
                    />
                    {validation.touched.name && validation.errors.name && (
                      <div className="text-danger">
                        {validation.errors.name}
                      </div>
                    )}
                  </Col>
                  <Col md={4}>
                    <Label>Price</Label>
                    <Input
                      name="price"
                      type="number"
                      placeholder="Enter price"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.price}
                      invalid={
                        validation.touched.price && validation.errors.price
                      }
                    />
                    {validation.touched.price && validation.errors.price && (
                      <div className="text-danger">
                        {validation.errors.price}
                      </div>
                    )}
                  </Col>
                  <Col md={4}>
                    <Label>Duration</Label>
                    <Input
                      type="select"
                      name="durationId"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.durationId}
                      invalid={
                        validation.touched.durationId &&
                        validation.errors.durationId
                      }
                    >
                      {durations.map(duration => (
                        <option key={duration.id} value={duration.id}>
                          {duration.value}
                        </option>
                      ))}
                    </Input>
                    {validation.touched.durationId &&
                      validation.errors.durationId && (
                        <div className="text-danger">
                          {validation.errors.durationId}
                        </div>
                      )}
                  </Col>
                </Row>
                <div
                  className="text-center mt-4"
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContet: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    type="submit"
                    color="primary"
                    className="px-3 border"
                    disabled={isSubmitting}
                  >
                    Update Service Profile
                  </Button>
                  {/* <button onClick={() => updatePatient1(patientData)}>Update</button>  */}

                  <Button
                    type="button"
                    color="danger"
                    className="px-3 border"
                    onClick={handleDelete}
                  >
                    Delete Service Profile
                  </Button>
                  <Button
                    type="button"
                    color="secondary"
                    className="px-3 border"
                    onClick={() => navigate("/service")}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </Container>
           {/* Delete Confirmation Modal */}
        <DeleteModel
         isOpen={showDeleteModal}
          toggle={() => setShowDeleteModal(false)}
          entityName="service"
          entityLabel={serviceData?.name}
          onConfirm={confirmDelete}/>
      </div>
      
    </React.Fragment>
  )
}

export default ServiceProfile
